import { Box } from 'braid-design-system';

import * as styles from './SvgImage.css';

interface Props {
  image: string;
}

export const SvgImage = ({ image }: Props) => (
  <Box
    height="full"
    className={styles.svgImage}
    style={{
      backgroundImage: `url('data:image/svg+xml;utf8,${image.replace(
        /\#/g,
        '%23',
      )}')`,

      maxWidth: '100%',
      maxHeight: '100%',
      margin: 'auto',
    }}
  />
);
